import { Box, IconButton, Image, Menu, MenuButton, MenuItem, MenuList, Text, CircularProgress } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { closeSlider, selectedMenu, setHeaderText } from "../../redux/actions/actions";
import Announcements from "./Announcements";
import IndividualLeadershipBoardCard from "./IndividualLeadershipBoardCard";
import Statistics from "./Statistics";
import { ReactComponent as PlusIcon } from '../../svg/plusIcon.svg'
import { loadLeadershipBoard } from "../../redux/api_calls/apiCalls";
import { useHistory } from "react-router";

export default function Dashboard() {
    const headerText = useSelector(state => state.headerState.headerText)
    const { leadershipBoardData, isLoading, leadershipBoardError } = useSelector(state => state.leadershipBoardState)
    const slider = useSelector(state => state.sliderState.sliderOpen)
    const [clicked, setClicked] = useState(false)
    const dispatch = useDispatch()
    const history = useHistory()

    useEffect(() => {
        dispatch(setHeaderText('Dashboard'))
        dispatch(selectedMenu(0))
        dispatch(loadLeadershipBoard())
    }, [dispatch])

    return (
        <Box
            d='flex'
            justifyContent='flex-start'
            alignItems='center'
            flexDirection='column'
            minH='90vh'
            pl={['0', '0', '0', slider ? window.innerWidth < 1400 ? '18vw' : '13vw' : '7.5vw']}
            transition='all 350ms ease'
            onClick={(e) => {
                e.stopPropagation()
                setClicked(false)
                dispatch(closeSlider())
            }}
        >

            <Box width={['95%', '95%', '95%', '80%']} justifyContent='space-between' alignItems='center' d='flex' mb='2rem'>
                <Text fontSize={['20px', '25px', '30px', '40px']} d={['none', 'none', 'none', 'flex']} fontWeight='900' style={{ fontFamily: 'Mulish, sans-serif' }}>{headerText}</Text>
            </Box>

            {/* {isLoading ? <Progress isIndeterminate size='xs' width='80%' /> :
                <> */}
            <Box
                width='80%'
                d='flex'
                justifyContent='space-between'
                mb='1.5rem'
            >
                <Box
                    w='27.5%'
                    d='flex'
                    flexDir='column'
                >
                    <Text
                        fontSize='15px'
                        color='#222222'
                        fontWeight='800'
                        style={{ fontFamily: 'Mulish, sans-serif' }}
                        mb='1rem'
                    >
                        LEADERSHIP BOARD
                    </Text>

                    <Box
                        w='100%'
                        border='1px solid rgba(0, 0, 0, 0.1)'
                        borderRadius='10px'
                        boxShadow='0px 2px 10px rgba(0, 0, 0, 0.1)'
                        pt='1rem'
                        bg='#ffffff'
                        height = '560px'
                        overflowX = 'auto'
                        sx={{
                            '&::-webkit-scrollbar': {
                                width: '5px',
                                borderRadius: '8px',
                                backgroundColor: `transparent`,
                                height: '90%',
                            },
                            '&::-webkit-scrollbar-thumb': {
                                backgroundColor: `rgba(0, 0, 0,0.2)`,
                                borderRadius: '20px'
                            },
                        }}
                    >
                        <Box
                            d='flex'
                            justifyContent='space-between'
                            alignItems='center'
                            mb='1rem'
                            px='1rem'
                        // pr='0.5rem'
                        >
                            <Text variant='custom' fontSize='10px' fontWeight='800' style={{ fontFamily: 'Mulish, sans-serif' }} width='15%'>RANK</Text>
                            <Text variant='custom' fontSize='10px' fontWeight='800' style={{ fontFamily: 'Mulish, sans-serif' }} width='65%' textAlign='start'>EMPLOYEE</Text>
                            <Text variant='custom' fontSize='10px' fontWeight='800' style={{ fontFamily: 'Mulish, sans-serif' }} width='15%' textAlign='center'>SCORE</Text>
                        </Box>
                        {
                            isLoading ? <Box width='100%' d='flex' justifyContent='center' alignItems='center' my='0.5rem'>
                                <CircularProgress isIndeterminate color='#3e59de' size='50px' />
                            </Box> :
                                !isLoading && leadershipBoardData.length > 0 ?
                                    leadershipBoardData.map((employee, idx) => <IndividualLeadershipBoardCard employee={employee} id={idx} key={idx} />) :
                                    <Box width='100%' d='flex' justifyContent='center' alignItems='center'>
                                        <Text
                                            style={{ fontFamily: 'Mulish, sans-serif' }}
                                            fontSize='16px'
                                            fontWeight='600'
                                            color='#222222'
                                        >
                                            {leadershipBoardError ? leadershipBoardError : "No Leadership Board Data Yet!"}
                                        </Text>
                                    </Box>
                        }

                    </Box>
                </Box>
                <Box
                    d='flex'
                    width='70%'
                    flexDir='column'
                >
                    <Statistics />
                    <Announcements />
                </Box>
            </Box>

            <Box
                width='80%'
                d='flex'
                justifyContent='space-between'
                flexDir='column'
            >
                <Text
                    fontSize='15px'
                    color='#222222'
                    fontWeight='800'
                    style={{ fontFamily: 'Mulish, sans-serif' }}
                    mb='1rem'
                >
                    PERFORMANCE
                </Text>
                <Box
                    w='100%'
                    border='1px solid rgba(0, 0, 0, 0.1)'
                    borderRadius='10px'
                    boxShadow='0px 2px 10px rgba(0, 0, 0, 0.1)'
                    bg='#ffffff'
                    objectFit='cover'
                    mb='1rem'
                >
                    <Image src='/images/performance-graph.jpg' alt='Graph' objectFit='cover' width='100%' height='100%' borderRadius='10px' />
                </Box>

            </Box>
            {/* </>
            } */}
            <Menu>
                <MenuButton
                    as={IconButton}
                    border='2px solid rgba(0, 0, 0, 0.1)'
                    icon={<PlusIcon width='45px' height='45px' />}
                    size='50px'
                    boxShadow='0px 14.2857px 17.8571px rgba(0, 0, 0, 0.14), 0px 3.57143px 35.7143px rgba(0, 0, 0, 0.12), 0px 7.14286px 14.2857px rgba(0, 0, 0, 0.2)'
                    borderRadius='50%'
                    position='fixed'
                    bg='#fd5f3a'
                    _hover={{ bg: '#ca4c2d' }}
                    _active={{ bg: '#ca4c2d' }}
                    right='2rem'
                    bottom='1rem'
                    objectFit='cover'
                    cursor='pointer'
                    transform={clicked ? 'rotate(-45deg)' : 'rotate(0)'}
                    onClick={(e) => {
                        e.stopPropagation()
                        setClicked(!clicked)
                    }}
                />
                <MenuList
                    style={{ fontFamily: 'Mulish, sans-serif' }}
                    fontWeight='700'
                    fontSize='15px'
                    color='#00000099'
                    borderRadius='10px'
                    boxShadow='0px 10px 50px rgba(0, 0, 0, 0.2)'
                >
                    <MenuItem onClick={() => setClicked(false)} >New Category</MenuItem>
                    <MenuItem onClick={() => history.push("/add-courses")} >New Course</MenuItem>
                    <MenuItem onClick={() => history.push("/add-live-courses")} >New Live</MenuItem>
                    <MenuItem onClick={() => history.push("/add-announcements")} >New Announcement</MenuItem>
                </MenuList>
            </Menu>
        </Box >
    )
}